import * as React from "react";
import { NavLink as Link } from "react-router-dom";
import styled from "styled-components";
import { Stack } from "@origin-digital/ods-core";
import { LinkChevron } from "@origin-digital/style-guide";
import { Loading } from "../Loading";
import { ILink } from "./SubCategoryList.types";

const StyledLinkChevron = styled(LinkChevron)`
  span {
    font-size: 16px;
  }
  &:hover {
    cursor: pointer;
  }
`;

const ArticleLink = styled(Link)`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.grey600};
  &:hover {
    color: ${({ theme }) => theme.colors.primary};
    text-decoration: none;
  }
`;

interface IProps {
  articles?: ILink[];
  max: number;
  loading: boolean;
  showMoreLink?: ILink;
  "data-id"?: string;
}

const numTotalArticles = (articles?: ILink[]): string => {
  return articles && articles.length > 0 ? `(${articles.length})` : "";
};

export const SubCategoryList = ({
  articles,
  max,
  loading,
  showMoreLink,
  "data-id": dataId = "subcategory-link",
}: IProps) => {
  const ArticleLinks = articles
    ?.map((article, idx) => (
      <ArticleLink
        data-id={`${dataId}${idx}`}
        to={article.route}
        key={article.title}
      >
        {article.title}
      </ArticleLink>
    ))
    .slice(0, max || articles.length);

  return (
    <Stack space="xlarge">
      {loading ? <Loading size="sm" /> : ArticleLinks}
      {showMoreLink && !loading && (
        <Link
          to={showMoreLink.route}
          key="show-all-link"
          data-id={`show-all-link-${dataId}`}
        >
          <StyledLinkChevron
            data-id={`subcategory-show-all-${dataId}`}
            text={`${showMoreLink.title} ${numTotalArticles(articles)}`}
          />
        </Link>
      )}
    </Stack>
  );
};
